import React, { useEffect } from "react";
import { withOktaAuth } from "@okta/okta-react";

export default withOktaAuth(function Logout({ oktaAuth, authState }) {
  useEffect(() => {
    // authState can be null initially
    if (!authState || authState.isPending) return;

    oktaAuth.signOut({
      postLogoutRedirectUri: window.location.origin
    });
  }, [oktaAuth, authState]);

  return <div>Logging out...</div>;
});